import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Image, usePrefersReducedMotion, useInterval, } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
const fadeInZoom = keyframes `
  0% { opacity: 0; transform: scale(1.08); }
  100% { opacity: 1; transform: scale(1); }
`;
const ImageSlider = ({ images, interval = 5000, borderRadius }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const prefersReducedMotion = usePrefersReducedMotion();
    // Handle image transition with animation
    const transitionToNextImage = () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            setIsTransitioning(false);
        }, 500); // Half a second for fade out before changing the image
    };
    // Auto slide functionality
    useInterval(() => {
        if (images.length > 1) {
            transitionToNextImage();
        }
    }, interval);
    // Handle clicking on dot indicators
    const handleDotClick = (index) => {
        if (index !== currentImageIndex) {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentImageIndex(index);
                setIsTransitioning(false);
            }, 500);
        }
    };
    if (!images || images.length === 0) {
        return (_jsx(Box, { w: "100%", h: "100%", bg: "gray.200", display: "flex", alignItems: "center", justifyContent: "center", children: "No images available" }));
    }
    const animation = prefersReducedMotion
        ? undefined
        : `${fadeInZoom} 1.5s ease-out`;
    return (_jsx(Box, { position: "relative", w: "100%", h: "100%", overflow: "hidden", borderRadius: borderRadius, children: _jsx(Image, { src: images[currentImageIndex], alt: `Slideshow image ${currentImageIndex + 1}`, objectFit: "cover", w: "100%", h: "100%", opacity: isTransitioning ? 0 : 1, animation: !isTransitioning ? animation : undefined, transition: "opacity 0.5s ease-out" }) }));
};
export default ImageSlider;
